import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/home';

function SiteNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 48);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-[72px] flex items-center justify-between gap-6">
        <a href="#top" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
          <span
            className={`w-9 h-9 rounded-md flex items-center justify-center font-heading text-lg font-bold transition-colors ${
              scrolled ? 'bg-primary-500 text-background-50' : 'bg-primary-500 text-background-50'
            }`}
          >
            爆
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-lg font-bold tracking-wide transition-colors ${
                scrolled ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              网红爆料
            </span>
            <span
              className={`hidden sm:block text-[10px] mt-0.5 tracking-[0.2em] transition-colors ${
                scrolled ? 'text-foreground-500' : 'text-background-200/80'
              }`}
            >
              EXPOSE · INSIDE
            </span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-7">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                scrolled
                  ? 'text-foreground-700 hover:text-primary-600'
                  : 'text-background-100/90 hover:text-background-50'
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#submit"
            className="whitespace-nowrap px-5 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer"
          >
            我要爆料
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((prev) => !prev)}
          className={`md:hidden w-9 h-9 flex items-center justify-center rounded-md border transition-colors cursor-pointer ${
            scrolled
              ? 'border-background-300 text-foreground-900'
              : 'border-background-100/40 text-background-50'
          }`}
        >
          <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200 px-4 py-4">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="py-3 text-sm text-foreground-800 border-b border-background-200/70 last:border-b-0 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#submit"
              onClick={() => setMenuOpen(false)}
              className="mt-4 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium text-center whitespace-nowrap cursor-pointer"
            >
              我要爆料
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}

export default SiteNavbar;